import { Link, router, useLocalSearchParams } from 'expo-router'
import { useState } from 'react'

import { useBookVrdhSchedulingSlot } from '@/api/hooks/useBookVrdhSchedulingSlot'
import type { VrdhSchedulingSlot } from '@/api/types/ProviderApi'
import ProtectedPage from '@/components/ProtectedPage'
import { BookingAction } from '@/components/ScheduleCallPage/BookingAction'
import { SchedulingSlots } from '@/components/ScheduleCallPage/SchedulingSlots'
import CloseIcon from '@/components/svgs/Close'
import Logo, { LogoColorVariant } from '@/components/svgs/Logo'
import { analytics } from '@/lib/analytics'
import { Screen } from '@/ui/core/screen'
import { HStack } from '@/ui/core/stack'
import { Image } from 'expo-image'
import { View } from 'react-native'
import Images from '#/assets/images/image-map'

export default function ScheduleVrdhCallScreen() {
	const { rescheduleCallId, callReason } = useLocalSearchParams<{
		rescheduleCallId?: string
		callReason?: string
	}>()
	const [selectedSlot, setSelectedSlot] = useState<VrdhSchedulingSlot | null>()
	const [isBooking, setIsBooking] = useState(false)
	const [isSchedulingSlot, setIsSchedulingSlot] = useState(false)

	const { mutate: bookVrdhSchedulingSlot } = useBookVrdhSchedulingSlot()

	const onSchedulingCancelled = () => {
		setIsBooking(false)
		setSelectedSlot(null)
	}

	const onSchedulingTriggered = () => {
		if (!selectedSlot || isSchedulingSlot) {
			return
		}

		setIsSchedulingSlot(true)

		bookVrdhSchedulingSlot(
			{ slot: selectedSlot, rescheduledEventId: rescheduleCallId, callReason },
			{
				onSuccess: () => {
					analytics.trackEvent('booked-vrdh-call', {
						startsAtUtc: selectedSlot.startTimeUtc,
						vrdhId: selectedSlot.vrdhId,
						vrdhReason: callReason ?? '',
					})

					router.push({
						pathname: '/call-confirmed',
						params: {
							startsAt: selectedSlot.startTimeUtc,
						},
					})
				},
			}
		)
	}

	const onSlotChosen = (slot: VrdhSchedulingSlot) => {
		setSelectedSlot(slot)
		setIsBooking(true)
	}

	return (
		<ProtectedPage>
			<HStack fullHeight>
				<Image
					style={{
						width: 16,
					}}
					source={Images.VerticalDivider}
					contentFit="cover"
				/>

				<Screen
					preset="fixed"
					className="flex-1"
					contentContainerClassName="flex gap-8 flex-col"
				>
					<HStack className="justify-between items-center lg:h-24 p-6 native:px-6 px-10">
						<View>
							<Logo color={LogoColorVariant.DARK} />
						</View>
						<Link href={'/'}>
							<CloseIcon />
						</Link>
					</HStack>
					<SchedulingSlots onSlotChosen={onSlotChosen} />
					{isBooking && (
						<BookingAction
							onCancelled={onSchedulingCancelled}
							onTriggered={onSchedulingTriggered}
						/>
					)}
				</Screen>
			</HStack>
		</ProtectedPage>
	)
}
